import { Link } from "react-router-dom";

const COLS = [
  { h: "Explore", links: [["Civilisation", "/civilisation"], ["Traditions", "/traditions"], ["Compare Traditions", "/compare"], ["Philosophy", "/philosophy"], ["Atlas", "/atlas"]] },
  { h: "Library", links: [["The Holy Book", "/library/holy-book"], ["Indic Civilisation", "/library/indic-civilisation"], ["Kali's Letters", "/library/kalis-letters"], ["Universal Search", "/search"]] },
  { h: "Institution", links: [["About INDIC", "/about"], ["Sources", "/sources"], ["Editorial Policy", "/editorial-policy"], ["Contribute", "/contribute"]] },
  { h: "Knowledge", links: [["INDIC Scholar", "/scholar"], ["INDIC Academy", "/learn"], ["Mandala Explorer", "/mandala"], ["Critical Studies", "/critical-studies"]] },
];

export default function Footer() {
  return (
    <footer className="relative border-t border-indic-gold/15 bg-[#080c1a]" data-testid="site-footer">
      <div className="mx-auto max-w-[1400px] px-4 sm:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-10">
          <div className="col-span-2">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-sm border border-indic-gold/50 text-indic-gold font-display text-xl">इ</span>
              <span className="font-display text-xl sm:text-2xl tracking-[0.1em] text-amber-50">Indic Civilisation</span>
            </div>
            <p className="mt-4 font-serif text-lg text-amber-100/80 italic max-w-xs">A Civilisation of Knowledge, Inquiry &amp; Imagination.</p>
            <p className="mt-6 text-sm text-slate-400">By <span className="text-indic-gold">Mahakali Tribunal</span></p>
            <p className="mt-1 text-xs font-sans uppercase tracking-[0.3em] text-slate-500">Intelligence · Justice · Wealth</p>
            <a href="https://mahakalitribunal.com/articles" target="_blank" rel="noreferrer" className="mt-4 inline-block text-sm text-indic-sandstone hover:text-indic-gold underline underline-offset-4" data-testid="tribunal-articles-link">
              mahakalitribunal.com / articles →
            </a>
          </div>
          {COLS.map((c) => (
            <div key={c.h}>
              <h4 className="font-sans text-xs font-semibold uppercase tracking-[0.2em] text-indic-gold/80">{c.h}</h4>
              <ul className="mt-4 space-y-2.5">
                {c.links.map(([label, to]) => (
                  <li key={to}>
                    <Link to={to} className="text-sm text-slate-400 hover:text-amber-50 transition-colors">{label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-14 pt-8 border-t border-indic-card-border flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} Mahakali Tribunal. Free to read. A public-interest knowledge institution.</p>
          <p className="text-xs text-slate-500 font-serif italic">Reality outranks authority.</p>
        </div>
      </div>
    </footer>
  );
}
